let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gQpJ0")).then(() => parcelRequire('8jEPG'));